import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { AuthorityNumbersSection } from '../components/sections/AuthorityNumbersSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { BonusSection } from '../components/sections/BonusSection';
import { ScarcitySection } from '../components/sections/ScarcitySection';
import { ValueAnchorSection } from '../components/sections/ValueAnchorSection';
import { PricingSection } from '../components/sections/PricingSection';
const TestimonialSection = lazy(() => import('../components/sections/TestimonialSection').then(m => ({
  default: m.TestimonialSection
})));
const GuaranteeSection = lazy(() => import('../components/sections/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('../components/sections/FAQSection').then(m => ({
  default: m.FAQSection
})));
const ClosingSection = lazy(() => import('../components/sections/ClosingSection').then(m => ({
  default: m.ClosingSection
})));
const FooterSection = lazy(() => import('../components/sections/FooterSection').then(m => ({
  default: m.FooterSection
})));
const SocialProofPopup = lazy(() => import('../components/ui/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="min-h-screen bg-background-dark text-gray-300 font-body selection:bg-primary/30 selection:text-white" data-id="element-461">
      <HeroSection data-id="element-462" />
      <ProblemSection data-id="element-463" />
      <AuthorityNumbersSection data-id="element-464" />
      <div className="lazy-section" data-id="element-465">
        <SolutionSection data-id="element-466" />
      </div>
      <div className="lazy-section" data-id="element-467">
        <BenefitsSection data-id="element-468" />
      </div>
      <div className="lazy-section" data-id="element-469">
        <BonusSection data-id="element-470" />
      </div>
      <div className="lazy-section" data-id="element-471">
        <ScarcitySection data-id="element-472" />
      </div>
      <div className="lazy-section" data-id="element-473">
        <ValueAnchorSection data-id="element-474" />
      </div>
      <div className="lazy-section" data-id="element-475">
        <PricingSection data-id="element-476" />
      </div>
      <Suspense fallback={<div className="py-12" data-id="element-478" />} data-id="element-477">
        <div className="lazy-section" data-id="element-479">
          <TestimonialSection data-id="element-480" />
        </div>
        <div className="lazy-section" data-id="element-481">
          <GuaranteeSection data-id="element-482" />
        </div>
        <div className="lazy-section" data-id="element-483">
          <FAQSection data-id="element-484" />
        </div>
        <div className="lazy-section" data-id="element-485">
          <ClosingSection data-id="element-486" />
        </div>
        <FooterSection data-id="element-487" />
        <SocialProofPopup data-id="element-488" />
      </Suspense>
    </main>;
}